import {ActionIcon, Button} from "@mantine/core";
import {useTranslation} from "react-i18next";
import {useChecklistData} from "./ChecklistDataContext";
import {useComment} from "./comments/CommentContext";
import CommentIcon from "../../../assets/v2-comment.svg?react";
import FilledCommentIcon from "../../../assets/v2-filled-comment.svg?react";
import {dibApi} from "../../chat/dibApi";

export const CommentButton = ({
    variant = "icon",
    nodeId,
}: {
    variant?: "icon" | "icontext";
    nodeId: string;
}) => {
    const {t} = useTranslation();
    const {collectionData, checklistConfig} = useChecklistData();
    const {setFocusedNode} = useComment();

    const topicId = checklistConfig.metadata.topicId;
    const collectionId = collectionData?.metadata?.collectionId ?? "";

    const {data: commentsData} = dibApi.endpoints.getComments.useQuery(
        {topicId, collectionId},
        {skip: !collectionId},
    );

    if (!collectionData) return null;

    const hasComment = Boolean(
        commentsData?.elementdata?.[nodeId]?.ci_comments?.length,
    );

    const Icon = hasComment ? FilledCommentIcon : CommentIcon;
    const color = hasComment ? "orange.5" : "gray";

    const handleClick = (e: React.MouseEvent) => {
        e.stopPropagation();
        setFocusedNode(nodeId, !hasComment);
    };

    if (variant === "icontext") {
        return (
            <Button
                variant="subtle"
                size="compact-sm"
                color={color}
                leftSection={<Icon width={16} height={16} />}
                onClick={handleClick}
            >
                {hasComment ? t("Action.EditComment") : t("Action.AddComment")}
            </Button>
        );
    }

    return (
        <ActionIcon
            variant="subtle"
            size="sm"
            color={color}
            onClick={handleClick}
        >
            <Icon width={16} height={16} />
        </ActionIcon>
    );
};
